import { isTeamWorkspaceOwner, type Team, type User } from '@kangaroo/shared';

export function viewerIsTeamWorkspaceOwner(user: User | null | undefined, team: Team | null | undefined) {
  if (team?.viewerIsWorkspaceOwner) {
    return true;
  }

  if (!user || !team) {
    return false;
  }

  return isTeamWorkspaceOwner(user, team);
}
